import React from 'react';
import { Paper } from '@mui/material';
import { styled } from '@mui/material';

type ContentCardProps = {
    bordered?: 'bordered';
    maxWidth?: string;
};

const StyledPaper = styled(Paper, {
    shouldForwardProp: (prop) => prop !== 'variant' && prop !== 'maxWidth',
})<ContentCardProps>(({ bordered, maxWidth }) => ({
    borderRadius: 10,
    border: bordered ? '1px solid #CACACA' : 'none',
    maxWidth: maxWidth || 'max-content',
}));

const ContentCard: React.FCC<ContentCardProps> = (props) => {
    return (
        <StyledPaper elevation={props.bordered ? 0 : 1} {...props}>
            {props.children}
        </StyledPaper>
    );
};

export default ContentCard;
